var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddNewInput(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9.91639,
    cy: 9.74427,
    r: 8.77209,
    fill: "white",
    stroke: "#7A7A7A",
    strokeWidth: 0.923378
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5764 10.9424H10.6778V13.9128H9.15677V10.9424H6.25818V9.5649H9.15677V6.59455H10.6778V9.5649H13.5764V10.9424Z",
    fill: "#7A7A7A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddNewInput);
export default __webpack_public_path__ + "static/media/addNewInput.0b7afc599e971deba236b2d15f29e912.svg";
export { ForwardRef as ReactComponent };